import React, { createContext, useContext, useEffect, useState } from 'react';
import { Helmet as OriginalHelmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { url } from '../../api/apiurl';
const SeoContext = createContext(null);
export function isPackagePath(path) {
 return /^\/(?:shop\/(?:products|product-standard|product-columnar|product-sidebar)|packages|package|packagess)(?:\/|$)/i.test(path);
}
export function PageSeoProvider({ children }) {
 const { pathname } = useLocation();
 const path = pathname.replace(/\/+$/, '') || '/';
 const [setting, setSetting] = useState(null);
 useEffect(() => {
  if (isPackagePath(path)) return undefined;
  const controller = new AbortController();
  fetch(`${url}/page-seo/resolve?path=${encodeURIComponent(path)}`, { signal: controller.signal })
   .then(response => response.ok ? response.json() : null)
   .then(data => { if (!controller.signal.aborted) setSetting(data?.path === path ? data : null); })
   .catch(() => { if (!controller.signal.aborted) setSetting(null); });
  return () => controller.abort();
 }, [path]);
 const value = !isPackagePath(path) && setting?.path === path ? setting : null;
 return <SeoContext.Provider value={value}>{children}</SeoContext.Provider>;
}
// Keep all existing Helmet content (canonical, robots, schema, social tags, etc.).
// Only configured title/description fields override their existing fallback.
export function Helmet({ children, ...props }) {
 const setting = useContext(SeoContext);
 if (!setting?.title && !setting?.description) return <OriginalHelmet {...props}>{children}</OriginalHelmet>;
 const filtered = React.Children.toArray(children).filter(child =>
  !(setting.title && child.type === 'title') && !(setting.description && child.type === 'meta' && child.props.name === 'description'));
 const meta = props.meta?.filter(item => !(setting.description && item.name === 'description'));
 return <OriginalHelmet {...props} {...(meta ? { meta } : {})} {...(setting.title ? { title: setting.title, titleTemplate: '%s' } : {})}>
  {filtered}
  {setting.title && <title>{setting.title}</title>}
  {setting.description && <meta name="description" content={setting.description} />}
 </OriginalHelmet>;
}
